import { FileDetails } from '../../../../shared/src/data/fileDetails'

export const filesKeyFactory = {
  all: ['files'] as const,
  files: (files?: FileDetails[]) => [
    ...filesKeyFactory.all,
    ...(files?.map(({ id }) => id).sort() || []),
  ],
}
